module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/tabination/full-width-pill/full-width-pill.component.scss
// module id = ./src/app/features/tabination/full-width-pill/full-width-pill.component.scss
// module chunks = main